// src/pages/Applications.jsx
import { useTranslation } from "react-i18next";
import { APPS } from "../data/apps";
import ApplicationCard from "../components/ApplicationCard";

export default function ApplicationsPage() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-6xl px-4 py-16">
      <header className="text-center">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">
          {t("applications.heading")}
        </h1>
        <p className="mt-3 text-slate-600">{t("applications.subheading")}</p>
      </header>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {APPS.map((app) => (
          <ApplicationCard key={app.slug} app={app} />
        ))}
      </div>

      <p className="mt-10 text-center text-slate-500 text-sm">
        {t("applications.note")}
      </p>
    </section>
  );
}
